import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import '../../../Styles/AddCompliance.css'
import { cn } from 'src/lib/utils'
import { useTranslation } from 'react-i18next'
import { BIN_Q_APPLICABLE_ID, BIN_Q_NOT_APPLICABLE_ID } from 'src/Entities/Governance'
import { RadioGroup, RadioGroupItem } from 'src/Common/ui/radio-group'
import ContentCircle from 'src/Common/ui/contentCircle'

const UserBinaryQuestionTable = ({ activeTab, arr, setSubmitValid, setSubmissionComplete, setArr, inputValidation, controls, control, data, errors, onInputChangeTextArea, onValueSelectChange, handleAddControls, handleDeleteControls, i }) => {
    // const [ currentPage, setCurrentPage ] = useState(1)

    // const rowsPerPage = 5
    // const totalPages = Math.ceil(data.length / rowsPerPage)
    // const handlePageChange = (event, value) => {
    //     setCurrentPage(value)
    // }

    const answerConvert = (code) => {
        switch (code) {
        case BIN_Q_APPLICABLE_ID:
            return '1'
        case BIN_Q_NOT_APPLICABLE_ID:
            return '2'
        default:
        {
            const find = data?.find((ele, i) => {
                if (ele?.questionUID === code) {
                    return ele
                } return false
            })
            return find?.questionUID
        }
        }
    }
    // const [ paginatedData, setPaginatedData ] = useState([])
    const { t } = useTranslation()
    useEffect(() => {
        const find = arr?.[arr?.length - 1]?.answer === '1'
        if (find) {
            setSubmitValid(true)
            setSubmissionComplete(false)
        } else {
            const subComp = arr?.[arr?.length - 1]?.answer === '2'
            if (subComp) {
                setSubmissionComplete(true)
                setSubmitValid(true)
            } else {
                setSubmitValid(false)
            }
        }
    }, [arr])
    const onValueChange = (value, j) => {
        const slicedArray = arr.map((item, i) => {
            if (i === j) {
                item.answer = value
            }
            return item
        }).slice(0, j + 1)
        if (value === '1' || value === '2') {
            setArr(slicedArray)
        } else {
            const sp = data.find(item => item.questionUID === value)
            slicedArray.push(sp)
            setArr(slicedArray)
        }
    }
    const recBinaryQuestions = (arrData) => {
        const a = arr
        a.push(arrData)
        setArr(a)
        if (arrData.answer === '1' || arrData.answer === '2' || !arrData.answer) {
            return true
        } else {
            const find = data.find((item) => item.questionUID === arrData?.answer)
            return recBinaryQuestions(find)
        }
    }
    useEffect(() => {
        if (arr?.length === 0) {
            recBinaryQuestions(data[0])
        }
    }, [data])
    return (
        <>
            {<>
                <div style={{ display: activeTab === 1 ? 'block' : 'none' }} className='h-[100%]'>
                    <div className='h-[90%]'>
                        <div>
                            <TableContainer className={cn('comp-table global-table')} style={{ maxHeight: 500 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow className='!bg-none'>
                                            <TableCell sx={{ border: 'none', backgroundColor: 'transparent' }} colSpan={2}></TableCell>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} align='center' className='binary-actions' colSpan={1}>{t('Actions')}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>#</TableCell>
                                            <TableCell className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                                <p className={cn('comp-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                    <div>{t('Questions')}</div>
                                                </p>
                                            </TableCell>
                                            <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                                <div className='flex justify-between border-b-[hsl]'>
                                                    <p className={cn('comp-table-th', 'flex flex-col flex-grow justify-center')}>
                                                        {t('Yes')}
                                                    </p>
                                                    <p className={cn('comp-table-th', 'flex flex-col flex-grow justify-center')}>
                                                        {t('No')}
                                                    </p>
                                                </div>
                                            </TableCell>
                                            <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                                <p className={cn('comp-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                    {'Status'}
                                                </p>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {arr?.map((item, j) => {
                                            item.sNo = j + 1
                                            return (
                                                <>
                                                    <TableRow sx={{ height: '30px' }}>
                                                        <TableCell align='center' >
                                                            <div className='w-full flex justify-center'>
                                                                <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary'} content={item.sNo} />
                                                            </div>
                                                        </TableCell>
                                                        <TableCell sx={{ height: '100%' }} >
                                                            <p className={cn('comp-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                                {<div style={{ whiteSpace: 'wrap' }} className='h-full'>{item.question}</div>
                                                                }
                                                            </p>
                                                        </TableCell>
                                                        {/* {!viewCondition() && <TableCell align='center' sx={{ color: 'hsl(var(--primary))' }}>
                                                    <p className={cn('comp-table-td')}>{t('Yes')}</p>
                                                </TableCell>} */}
                                                        <RadioGroup style={{ borderBottom: '1.5px solid hsl(var(--primary-foreground))' }} className='flex justify-around mt-3'
                                                            value={item.answer}
                                                            onValueChange={(e) => {
                                                                const value = e
                                                                onValueChange(value, j)
                                                            }}>
                                                            <TableCell align='center' sx={{}}>
                                                                <div className='flex items-center'>
                                                                    <RadioGroupItem style={{ flexShrink: 0 }} value={answerConvert(item.connections[0]?.hieID === '0' ? item.connections[0]?.action : item.connections[0]?.hieID)} />
                                                                </div>
                                                            </TableCell>
                                                            <TableCell align='center' sx={{ margin: 0 }}>
                                                                <div className='flex items-center '>
                                                                    <RadioGroupItem style={{ flexShrink: 0 }} value={answerConvert(item.connections[1]?.hieID === '0' ? item.connections[1]?.action : item.connections[1]?.hieID)} />
                                                                </div>
                                                            </TableCell>
                                                        </RadioGroup>
                                                        <TableCell align='center' sx={{ whiteSpace: 'nowrap' }}>{item?.answer === '1' || item?.answer === '2' ? <div className={'text-[hsl(var(--Low))] font-semibold mt-2'}>{item?.answer === '1' ? 'Applicable' : 'Not applicable'}</div> : null}</TableCell>
                                                    </TableRow>
                                                </>

                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                    {/* {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                        <div className='flex gap-2 items-center text-primary' onClick={() => { handleAddControls('binaryQuestions') } }><AddSquareIcon /> <span>New</span></div>
                    </div>} */}
                    {/* {data.length > 0 && <div className="flex items-center justify-between mt-2 p-4 h-[10%]">
                        <Typography className="text-muted">
                                Showing data {currentPage} to {rowsPerPage} of {totalPages} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded" />
                    </div>} */}
                </div>
            </>
            }
        </>
    )
}

UserBinaryQuestionTable.propTypes = {
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onValueSelectChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    i: PropTypes.number,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.func,
    arr: PropTypes.any,
    setSubmitValid: PropTypes.any,
    setSubmissionComplete: PropTypes.any,
    setArr: PropTypes.any
}

export default UserBinaryQuestionTable
